import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { fetchParameterCategories } from '../services/configuration.service';
import type { ConfigurationPlatform } from '../types/configuration.types';

import { usePlatformId } from './usePlatformId';

/**
 * Fetches the category catalog for the selected platform. Drives the
 * Configuration Manager rail (order, section grouping, counts) and lets
 * the page resolve a parameter's `category` UUID to a human label.
 *
 * Gated on the platform UUID so the X-Platform-ID header is never missing
 * on the wire. Categories change at deploy cadence, so the cache stays
 * fresh for the full session.
 */
export function useParameterCategories(params: { platform: ConfigurationPlatform }) {
  const platformId = usePlatformId(params.platform);

  return useQuery({
    queryKey: queryKeys.configuration.parameterCategories(platformId ?? ''),
    queryFn: () => fetchParameterCategories(platformId ?? ''),
    enabled: !!platformId,
    staleTime: Infinity,
  });
}
